export default "__VITE_ASSET__CGvZeLSw__"